/* Global analytics controller which orchestrates pushing into the datalayer from across the code base */

/*To use, either use one of the functions below or attach the [data-analytics-track] or [data-analytics-page-view] attributes to a DOM element for automatic tracking. 
With [data-analytics-track] passing any value will assume it is an event and bind it to the event based tracking, for example [data-analytics-track="click"]. */

/* Example use cases */

/*
// attach click handler to elements (reads data attributes - data-track-event, data-track-category, data-track-action, data-track-label, data-product-name (optional))
window.JC.analyticsController.attach($('[data-analytics-track]'), 'click');

//attach with specific keypress, but otherwise same as above
window.JC.analyticsController.attachKeyPress($('[data-analytics-track]'), 13);

//track from code
window.JC.analyticsController.track({event:'a', category:'b', action:'c', label:'d'});

//track virtual page view with code
window.JC.analyticsController.pageView('sign-in/success', 'Sign-in-Form-Success');

// track virtual page view from DOM
<div data-analytics-page-view="true" data-virtualpageuRL="sign-in/success" data-virtualpagetitle="Sign-in-Form-Success"></div>
*/

import $ from "../vendor/jquery";
var jQuery = $;

+(function ($) {
  window.JC = window.JC || {};

  window.JC.analyticsController = (function () {
    window.dataLayer = window.dataLayer || [];

    var enterKeyCode = 13;
    var analyticsTrigger = "[data-analytics-track]";
    var analyticsPageViewTrigger = "[data-analytics-page-view]";

    function attachEventBasedTracking(elements, eventType) {
      elements.each(function (index, element) {
        element = $(element);
        attachTracking(element, eventType);
      });
    }

    /* May be redundant and handled by click, but included just in case */
    function attachKeyPressBasedTracking(elements, eventkeyCode) {
      elements.each(function (index, element) {
        element = $(element);
        attachKeyPressTracking(element, eventkeyCode);
      });
    }

    function attachTracking(element, eventType) {
      if (typeof eventType !== "undefined") {
        element.off(eventType, trackEvent).on(eventType, trackEvent);
      }
    }

    function attachKeyPressTracking(element, eventkeyCode) {
      if (typeof eventType !== "undefined") {
        element.off("keypress").on(eventType, function (event) {
          if (event.which == enterKeyCode) {
            trackEvent();
          }
        });
      }
    }

    function trackEvent() {
      var element = $(this);
      track(element);
    }

    function trackEcommerce(data) {
      dataLayer.push({ ecommerce: null });
      dataLayer.push(data);      
    }

    function track(element) {
      var data = {};
      (data.event = element.data("trackEvent") || ""),
        (data.category = element.data("trackCategory") || ""),
        (data.action = element.data("trackAction") || ""),
        (data.label = element.data("trackLabel") || "");

      if (typeof element.data("productName") !== "undefined") {
        data.productName = element.data("productName") || "";
      }

      if (typeof element.data("trackCtatype") !== "undefined") {
        data.ctaType = element.data("trackCtatype") || "";
      }

      analyticsTrack(data);
    }

    function analyticsTrack(data, dataLayer) {
      dataLayer = dataLayer || window.dataLayer;
      dataLayer.push(data);

      // if (typeof data.productName !== "undefined") {
      //   ga("send", "product-name", {
      //     "Product Name": data.productName,
      //   });
      // }
    }

    function trackVirtualPageView(virtualPageURL, virtualPageTitle, eventName, dataLayer) {
      var data, tagsFired;

      virtualPageURL = virtualPageURL.toString();

      eventName = eventName || "content-view";
      dataLayer = dataLayer || window.dataLayer;

      // If the virtual url doesn't start with a slash, then make it relative to the current URL
      if (virtualPageURL.charAt(0) !== "/") {
        var pathname = window.location.pathname;
        if (pathname.charAt(pathname.length - 1) !== "/") {
          pathname = pathname + "/";
        }
        virtualPageURL = pathname + virtualPageURL;
      }

      data = {
        event: eventName,
        virtualPageURL: virtualPageURL || "",
        virtualPageTitle: virtualPageTitle || "",
      };

      tagsFired = dataLayer.push(data);
      tagsFired = tagsFired || (!isNaN(parseFloat(tagsFired)) && isFinite(tagsFired));
    }

    function trackVirtualPageViewFromAttributes(element) {
      trackVirtualPageView(element.data("virtualpageurl") || "", element.data("virtualpagetitle") || "");
    }

    // Some DOM element should only trigger tracking events when they are seen by the user
    var elementTracking = {
      elements: [],

      add: function (element) {
        this.elements.push(element);
      },

      checkAllElements: function () {
        for (var x = 0; x < elementTracking.elements.length; x++) {
          elementTracking.checkElement(elementTracking.elements[x]);
        }
      },

      checkElement: function (element) {
        var $elements = this.elements;

        function goAhead(element) {
          track(element);
          // Remove it from the array so we don't check it again
          var index = $elements.indexOf(element);
          if (index > -1) {
            $elements.splice(index, 1);
          }
        }

        function isElementHidden(el) {
          return $(el)[0].offsetParent === null;
        }

        function elementInViewport(element) {
          var $element = $(element);

          var viewportTop = $(window).scrollTop();
          var viewportBottom = viewportTop + $(window).height();

          var elementTop = $element.offset().top;
          var elementBottom = elementTop + $element.height();

          return elementBottom <= viewportBottom && elementTop >= viewportTop;
        }

        if (element.data("trackVisibility") === false) {
          goAhead(element);
        } else {
          // Check the element is both visible and in the viewport
          if (!isElementHidden(element) && elementInViewport(element)) {
            goAhead(element);
          }
        }
      },

      init: function () {
        if (this.elements.length > 0) {
          $(window).on("throttled-resize", elementTracking.checkAllElements);
          $(window).on("scroll", elementTracking.checkAllElements);
          elementTracking.checkAllElements();
        }
      },
    };

    $(function () {
      $(analyticsPageViewTrigger).each(function (index, value) {
        var element = $(value);
        trackVirtualPageViewFromAttributes(element);
      });

      $(analyticsTrigger).each(function (index, value) {
        var element = $(value);
        var type = element.data("analyticsTrack");
        // elements can trigger events immediately (but not if they're hidden with CSS)
        if (typeof type == "undefined" || type == "") {
          elementTracking.add(element);
        } else {
          attachEventBasedTracking(element, type);
        }
      });

      elementTracking.init();
    });

    //hook up object based tracking
    return {
      attach: attachEventBasedTracking,
      attachKeyPress: attachKeyPressBasedTracking,
      track: analyticsTrack,
      trackEcommerce: trackEcommerce,
      pageView: trackVirtualPageView,
    };
  })();
})(jQuery);
